import { Card, CardContent, CardHeader } from '@material-ui/core';
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';
import { Finding } from '../utils/types';
import { groupByMonth } from '../utils/severity';
import { EmptyChart } from './EmptyChart';

interface TrendLineChartProps {
  findings: Finding[];
}

export const TrendLineChart = ({ findings }: TrendLineChartProps) => {
  const data = groupByMonth(findings);
  const hasData = data.some(d => d.count > 0);

  if (!hasData) {
    return <EmptyChart title="Tendência (6 meses)" />;
  }

  return (
    <Card>
      <CardHeader title="Tendência (6 meses)" />
      <CardContent>
        <ResponsiveContainer width="100%" height={250}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line
              type="monotone"
              dataKey="count"
              stroke="#1976d2"
              strokeWidth={2}
              dot
            />
          </LineChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
